<div class="container client-identifier-list">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <p-toast></p-toast>
                <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
                <p-table
                    #dt
                    [value]="clientIdentifiers"
                    dataKey="id"
                    [tableStyle]="{'min-width': '50rem'}"
                    [paginator]="true"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [styleClass]="'p-datatable-sm'"
                    [globalFilterFields]="['name']"
                    [scrollable]="true" 
                    scrollHeight="600px"
                >
                    <ng-template pTemplate="caption">
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <h4 class="mt-2">{{ integrationName }}</h4>
                            </div>
                            <div class="col-md-6 text-right">
                                <p-button
                                    icon="pi pi-plus"
                                    styleClass="p-button-sm"
                                    [label]="'Add Client Identifier'"
                                    (click)="addEditClientIdentifier()"
                                ></p-button>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th
                                pSortableColumn="identifier"
                            >
                                Generic Integration Client Id <p-sortIcon field="identifier"></p-sortIcon>
                            </th>
                            <th
                                pSortableColumn="integrationClientId"
                            >
                                Client Id <p-sortIcon field="integrationClientId"></p-sortIcon>
                            </th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-clientIdentifier>
                        <tr>
                            <td>{{ clientIdentifier.identifier }}</td>
                            <td>{{ clientIdentifier.integrationClientId }}</td>
                            <td>
                                <p-button
                                    [icon]="'pi pi-pencil'"
                                    [styleClass]="'p-button-rounded p-button-text'"
                                    (click)="addEditClientIdentifier(clientIdentifier)"
                                ></p-button>
                                <p-button
                                    [icon]="'pi pi-trash'"
                                    [styleClass]="'p-button-rounded p-button-text p-button-danger'"
                                    (click)="onShowDeleteConfirm(clientIdentifier)"
                                ></p-button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>